// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const BOT_SYSTEM_DESCRIPTOR = msg({
	message: 'Bot System',
	comment: 'Bot catalog page heading and navigation label. Turkish: Bot Sistemi.',
});
export const CREATE_YOUR_OWN_BOT_DESCRIPTOR = msg({
	message: 'Create your own bot',
	comment: 'Opens the developer applications tab in user settings from the bot catalog.',
});
export const DEVELOPER_DOCUMENTATION_DESCRIPTOR = msg({
	message: 'Developer documentation',
	comment: 'Button opening sanalyer developer documentation with the external link warning.',
});
